import { useParams } from '@tanstack/react-router';
import { resolveActiveWorkspace, useAccessContext } from '@vizit/access';
import type { RouteContext } from '../router/router-provider/types';
import { workspaceRoute } from '../router/workspace-routes';

export function resolveLoaderWorkspaceId(context: RouteContext, workspaceSlug: string): string | null {
  const me = context.access?.me;
  return me ? resolveActiveWorkspace(me, { workspaceSlug }) : null;
}

export function useOptionalParam(key: string): string | undefined {
  const params = useParams({ strict: false }) as Record<string, unknown>;
  const value = params[key];

  return typeof value === 'string' ? value : undefined;
}

export function useWorkspaceSlug(): string | undefined {
  return useOptionalParam('workspaceSlug');
}

export function useActiveWorkspaceId(): string | null {
  const { me } = useAccessContext();
  const workspaceSlug = useWorkspaceSlug();

  return me ? resolveActiveWorkspace(me, { workspaceSlug }) : null;
}

export function useWorkspaceLink(subpath = '/'): string {
  const workspaceSlug = useWorkspaceSlug();

  if (!workspaceSlug) {
    throw new Error('useWorkspaceLink must be used within a /w/:workspaceSlug route');
  }

  return workspaceRoute(workspaceSlug, subpath);
}
